import { createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';
import http from 'utils/http';
import { setErrorWithoutSnack } from 'utils/helpers/fetch';

const initialState = {
  error: '',
  pending: false,
  response: {},
};

const reducers = {
  cancelPtoError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  cancelPtoPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  cancelPtoReset() {
    return initialState;
  },
  cancelPtoResetError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  cancelPtoSuccess(state, { payload }) {
    return R.assoc('response', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'cancelPto',
  reducers,
});

export const {
  cancelPtoPending,
  cancelPtoSuccess,
  cancelPtoError,
  cancelPtoReset,
  cancelPtoResetError,
} = actions;

// Actions
let cancelController;
export function sendCancelPto(params = {}) {
  return dispatch => {
    dispatch(cancelPtoPending(true));
    if (cancelController) cancelController.abort();
    cancelController = new AbortController();
    const { signal } = cancelController;
    return http
      .post('/product-transfer-orders/cancel', params, { signal })
      .then(res => {
        dispatch(cancelPtoError(''));
        dispatch(cancelPtoSuccess(res.data));
        dispatch(cancelPtoPending(false));
      })
      .catch(error => {
        setErrorWithoutSnack(error, dispatch, cancelPtoError);
      });
  };
}

export const resetCancelPtoError = () => dispatch => {
  dispatch(cancelPtoResetError(null));
};

export default reducer;
